import CalculatorIcon from '../../../../../icons/calculator.svg?react';
import DollarTagIcon from '../../../../../icons/dollar-tag.svg?react';
import HandSelectClickIcon from '../../../../../icons/hand-select-click.svg?react';
import UserIcon from '../../../../../icons/user.svg?react';
import DocumentIcon from '../../../../../icons/document.svg?react';

export default function PurchasingProcessData() {
    return {
        subtitle: "Using Covr's Whole Life Insurance Quoter gives you the best choices from the market.",
        image: "/product-landing/perm/circle1.png",
        steps: [
            {
                title: "Needs Analysis",
                icon: CalculatorIcon,
                paragraphs: [
                    "Unsure how much coverage to purchase for your family’s unique situation? Our needs analysis tool will guide you in determining the right amount of life insurance for your life and budget."
                ]
            },

            {
                title: "Get a Quote",
                icon: DollarTagIcon,
                paragraphs: [
                    "Covr makes it easy! Simply use our online quoter to enter your information and see an instant quote from the life insurance company.",
                ]
            },
            {
                title: "The Application Process",
                icon: HandSelectClickIcon,
                paragraphs: [
                    "To start your application, simply enter your personal information, beneficiary information and medical history. Sign the application digitally.",
                ]
            },
            {
                title: "Underwriting and Decision",
                icon: UserIcon,
                paragraphs: [
                    "Once you sign the application, the life insurance company will make a decision based on the information provided in your application - no medical exam required.",
                ]
            },
            {
                title: "Accepting Your Policy",
                icon: DocumentIcon,
                paragraphs: [
                    "Assuming you accept the offer, your life insurance policy will be physically mailed from the life insurance company. If your application is declined, don’t worry - one of our licensed concierge team members will reach out to discuss other carrier and product options to help you obtain the coverage you need.",
                ]
            }
        ]
    }
}